// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__HOmkg","buttons":"Footer_buttons__3zirl"};